import { MotionConfig } from 'framer-motion';
import { AchievementsTracker } from './achievements';
import { AchievementToast, ErrorBoundary, ToastProvider } from './components';
import { StoreProvider, useAppData } from './data';
import { ProProvider } from './pro';
import { InstallBanner, OfflineBanner } from './pwa';
import { RatePromptProvider } from './rating';
import { Onboarding } from './screens/onboarding';
import { TabNavigator } from './screens/TabNavigator';
import { AuthProvider, SignInSheet } from './supabase';
import { WalkthroughPanel, WalkthroughProvider } from './walkthrough';

export default function App() {
  // MotionConfig reducedMotion="user" makes Framer Motion respect the
  // OS-level prefers-reduced-motion preference automatically — transforms
  // collapse to opacity-only when it's on. CSS-driven animations get the
  // same treatment via the @media block in src/index.css.
  return (
    <ErrorBoundary>
      <MotionConfig reducedMotion="user">
        <StoreProvider>
          <ToastProvider>
            <AchievementsTracker />
            <AuthProvider>
              <ProProvider>
                <WalkthroughProvider>
                  <RatePromptProvider>
                    <OfflineBanner />
                    <AppShell />
                    <AchievementToast />
                    <SignInSheet />
                  </RatePromptProvider>
                </WalkthroughProvider>
              </ProProvider>
            </AuthProvider>
          </ToastProvider>
        </StoreProvider>
      </MotionConfig>
    </ErrorBoundary>
  );
}

/**
 * Top-level conditional: until the user finishes onboarding we render the
 * onboarding flow; once `profile.onboardingComplete` flips, the tab
 * navigator takes over and the walkthrough panel becomes available.
 */
function AppShell() {
  const data = useAppData();
  if (!data.profile.onboardingComplete) {
    return <Onboarding />;
  }
  return (
    <>
      <TabNavigator />
      <WalkthroughPanel />
      <InstallBanner />
    </>
  );
}
